import LayerGroup from 'ol/layer/Group'

// function to be added to OpenLayers.Map.prototype if needed
// 'this' in the function is the map object

const getLayerByName = function (layerName) {
  let layer,
      layers;

  const processLayer = function (layer) {
    let foundLayer;

    if (layer instanceof LayerGroup) {
      let groupLayers = layer.getLayers().getArray();
      for (let i =0, ii = groupLayers.length; i < ii; i++) {
        foundLayer = processLayer(groupLayers[i]);
        if (foundLayer) {
          break;
        }
      }
    } else if (layerName === layer.get('layerName')) {
      foundLayer = layer;
    }
    return foundLayer;
  };

  layers = this.getLayers().getArray();
  for (let i = 0, ii = layers.length; i < ii; i++) {
      layer = processLayer(layers[i]);
      if (layer) {
          break;
      }
  }
  return layer;
};

export default getLayerByName;
